define('collection/ClassesCollection',['require','lib/collection/BaseCollection','underscore','model/ClassesModel','model/TimeSlotModel','model/GroupedTimeSlotsModel','backbone','Config'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
    var ClassesModel = require('model/ClassesModel');
    var TimeSlotModel = require('model/TimeSlotModel');
    var GroupedTimeSlotsModel = require('model/GroupedTimeSlotsModel');
    var Backbone = require('backbone');
    var Config = require('Config');

    /**
     * Classes collection
     *
     * @class ClassesCollection
     */
    return BaseCollection.extend({

        url: '/booking/classes/',
        model: ClassesModel,
        _timeCollection: new Backbone.Collection(),
        _providerCollection: new Backbone.Collection(),

        /**
         * Returns collection of available timeslots
         *
         * @return {Backbone.Collection}
         */
        getTimeCollection: function () {
            var min = null;
            var max = null;
            var date = null;
            var diffs = [];
            this.each(function (model) {
                var from = new Time(model.get('from'));
                var to = new Time(model.get('to'));

                // per-date client offset sent by the server with each class (DST), see TimelineModel::_formatClassesModel
                if (model.has('time_diff')) {
                    diffs.push({from: from.getInteger(), diff: model.get('time_diff')});
                }

                if (max === null || to.getInteger() > max) {
                    max = to.getInteger();
                }
                if (min === null || from.getInteger() < min) {
                    min = from.getInteger();
                }
                date = model.get('date');
            });

            this._buildTimeCollection(min, max, date, _.sortBy(diffs, 'from'));

            return this._timeCollection;
        },

        /**
         * Returns timeslots grouped by provider
         *
         * @param array providers
         * @return {Backbone.Collection}
         */
        getProviderCollection: function (providers) {
            var models = {};
            this.each(function (model) {
                if (providers && _.indexOf(providers, model.get('provider_id') + '') === -1) {
                    return;
                }
                if (!models[model.get('provider_id')]) {
                    models[model.get('provider_id')] = new GroupedTimeSlotsModel({
                        'provider_id': model.get('provider_id'),
                        'collection': new Backbone.Collection()
                    });
                }

                models[model.get('provider_id')].get('collection').add(model);
            });

            var result = [];
            _.each(providers, function (id) {
                if (!models.hasOwnProperty(id)) {
                    return;
                }
                result.push(models[id]);
            }, this);

            this._providerCollection.reset(result);

            return this._providerCollection;
        },

        /**
         * Builds available time slots
         *
         * @param Integer from
         * @param Integer to
         * @param String date
         * @param Array diffs [{from: minutes, diff: minutes}] sorted by from - client offset of the classes
         * @private
         */
        _buildTimeCollection: function (from, to, date, diffs) {
            var timeframe = Config.getInstance().getTimeFrame();

            var models = [];
            for (var slot = from; slot < to; slot += timeframe) {
                var time = new Time(slot);
                var timeStr = time.getFormattedTime('24hr');

                var attrs = {
                    'id': date + ' ' + timeStr,
                    'time': timeStr,
                    'date': date
                };
                // row label offset: the one of the latest class starting at or before this row (first class otherwise)
                if (diffs && diffs.length) {
                    var match = diffs[0];
                    _.each(diffs, function (item) {
                        if (item.from <= slot) {
                            match = item;
                        }
                    });
                    attrs.time_diff = match.diff;
                }

                models.push(new TimeSlotModel(attrs));
            }
            this._timeCollection.reset(models);
        }

    });

});
